import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	drawerItems: {
		padding: theme.spacing(1),
	  },
}));